import { formConstants } from '../../../../utils/constants/form-constants';

const ChangePasswordFormData = (accountFormData, userAccountData) => {
    function buildChangePasswordFormData() {
        const { ssoChangePasswordFields } = accountFormData;
        const formData = {};
        const { formTitle, callBackUrl, actionSuccessText } = ssoChangePasswordFields;
        formData[formConstants.formTitle] = formTitle;
        formData[formConstants.callBackUrl] = callBackUrl;
        formData[formConstants.actionSuccessText] = actionSuccessText;

        formData[formConstants.username] = ssoChangePasswordFields[formConstants.username];
        formData[formConstants.username].defaultValue = userAccountData[formConstants.email];
        formData[formConstants.oldPassword] = ssoChangePasswordFields[formConstants.oldPassword];
        formData[formConstants.password] = ssoChangePasswordFields[formConstants.password];
        formData[formConstants.confirmPassword] = ssoChangePasswordFields[formConstants.confirmPassword];

        return formData;
    }


    return buildChangePasswordFormData();
};

export default ChangePasswordFormData;
